import { connect } from 'react-redux';
import SalesloftView from './SalesloftView.jsx';
import { fetchIntegrations } from "src/legacy/redux/actions/integrations.jsx";
import { authenticateAccount } from 'src/legacy/redux/actions/integrations/salesloft.jsx';  
import {trackAdoptionMetricsForPluginConnectedEvent} from "src/legacy/redux/actions/adoption";
import withUseHooks from 'src/legacy/components/withUseHooks.jsx';
import { getIntegrationForType } from 'src/legacy/redux/actions/integrations.jsx';

const mapStateToProps = (state, ownProps) => {
  let integration = getIntegrationForType(state, 'salesloft');
  return {
    integration: integration,
    integrations: state.legacyRootReducer.settings.integrations,
    user: state.users.me,
    deactivating: state.legacyRootReducer.settings.integrations.activated.deactivating.loading,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    authenticateAccount: (code) => {
      return dispatch(authenticateAccount(code));
    },
    
    fetchIntegrations: () => {
      return dispatch(fetchIntegrations());
    },
    trackAdoptionMetricsForPluginConnectedEvent : (partnerName) => {
      return dispatch(trackAdoptionMetricsForPluginConnectedEvent(partnerName));
    }
    
  }
}

const SalesloftPage = connect (
    mapStateToProps,
    mapDispatchToProps
)(SalesloftView);

export default withUseHooks(SalesloftPage);
